import { RootState } from 'app'

export const getTags = (state: RootState) => state.tagsModule.tags
export const getDeviceTags = (state: RootState) => state.tagsModule.tags.display
export const getAddTags = (state: RootState) => state.tagsModule.addTag
export const getDeleteTemplateTag = (state: RootState) =>
  state.tagsModule.deleteTemplateTag
export const getDeleteDisplayTag = (state: RootState) =>
  state.tagsModule.deleteDisplayTag
